module.exports = __webpack_public_path__ + "static/img/pic.4c7025d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/download/pic.png
// module id = Ggtq
// module chunks = 6